import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
export const SUPPORTED_EMAIL_TYPES = [EMAIL_TYPE.BATCH_EMAIL];
export const FRAMEWORK_INSIGHT_CONTEXT = {
  GLOBAL_BENCHMARK_CONTEXT: 'GLOBAL_BENCHMARK_CONTEXT',
  INDUSTRY_BENCHMARK_CONTEXT: 'INDUSTRY_BENCHMARK_CONTEXT',
  PORTAL_CONTEXT: 'PORTAL_CONTEXT',
  BUSINESS_UNIT_CONTEXT: 'BUSINESS_UNIT_CONTEXT',
  PRODUCT_CAMPAIGN_CONTEXT: 'PRODUCT_CAMPAIGN_CONTEXT',
  SAME_EMAIL_MONTH_OVER_MONTH_CONTEXT: 'SAME_EMAIL_MONTH_OVER_MONTH_CONTEXT',
  OTHER_EMAILS_SAME_WORKFLOW_CONTEXT: 'OTHER_EMAILS_SAME_WORKFLOW_CONTEXT'
};
export const FRAMEWORK_INSIGHT_PROPERTY = {
  OPEN_RATE: 'OPEN_RATE',
  CLICK_TO_OPEN_RATE: 'CLICK_TO_OPEN_RATE',
  CLICK_TO_DELIVERED_RATE: 'CLICK_TO_DELIVERED_RATE',
  SPAM_REPORT_RATE: 'SPAM_REPORT_RATE',
  HARD_BOUNCE_RATE: 'HARD_BOUNCE_RATE',
  BOUNCE_RATE: 'BOUNCE_RATE',
  UNSUBSCRIBE_RATE: 'UNSUBSCRIBE_RATE'
};
export const FRAMEWORK_INSIGHT_POLARITY = {
  GOOD: 'GOOD',
  BAD: 'BAD'
};
export const FRAMEWORK_PROPERTY_TO_INSIGHT_PROPERTY = {
  hs_open_rate: FRAMEWORK_INSIGHT_PROPERTY.OPEN_RATE,
  hs_clickthrough_rate: FRAMEWORK_INSIGHT_PROPERTY.CLICK_TO_OPEN_RATE,
  hs_click_rate: FRAMEWORK_INSIGHT_PROPERTY.CLICK_TO_DELIVERED_RATE,
  hs_spam_reports_rate: FRAMEWORK_INSIGHT_PROPERTY.SPAM_REPORT_RATE,
  hs_hard_bounces_rate: FRAMEWORK_INSIGHT_PROPERTY.HARD_BOUNCE_RATE,
  hs_bounce_rate: FRAMEWORK_INSIGHT_PROPERTY.BOUNCE_RATE,
  hs_unsubscribe_rate: FRAMEWORK_INSIGHT_PROPERTY.UNSUBSCRIBE_RATE
};
export const FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE = {
  GLOBAL_BENCHMARK_CONTEXT: 'GLOBAL_BENCHMARK',
  INDUSTRY_BENCHMARK_CONTEXT: 'INDUSTRY_BENCHMARK',
  PORTAL_CONTEXT: 'PORTAL',
  BUSINESS_UNIT_CONTEXT: 'BUSINESS_UNIT',
  PRODUCT_CAMPAIGN_CONTEXT: 'PRODUCT_CAMPAIGN',
  SAME_EMAIL_MONTH_OVER_MONTH_CONTEXT: 'SAME_EMAIL_MONTH_OVER_MONTH',
  OTHER_EMAILS_SAME_WORKFLOW_CONTEXT: 'GROUP'
};
export const INSIGHT_LISTING_PANEL_TAB = {
  TO_IMPROVE: 'TO_IMPROVE',
  DOING_GOOD: 'DOING_GOOD'
};
export const BENCHMARK_TYPE = {
  GLOBAL: 'GLOBAL',
  INDUSTRY: 'INDUSTRY'
};